import { render, staticRenderFns } from "./lklOpening.vue?vue&type=template&id=60292ada&scoped=true&"
import script from "./lklOpening.vue?vue&type=script&lang=js&"
export * from "./lklOpening.vue?vue&type=script&lang=js&"
import style0 from "./lklOpening.vue?vue&type=style&index=0&id=60292ada&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60292ada",
  null
  
)

export default component.exports